import React from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { Problem } from './components/sections/Problem';
import { Tomos } from './components/sections/Tomos';
import { Bonos } from './components/sections/Bonos';
import { Offer } from './components/sections/Offer';
import { PlanMaestro } from './components/sections/PlanMaestro';
import { MoreTestimonials } from './components/sections/MoreTestimonials';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { CostOfInaction } from './components/sections/CostOfInaction';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-charcoal" data-id="element-0" data-mp="28tme50nv46w6">
      <Hero data-id="element-1" data-mp="23vkvggucm9l8" />
      <main data-id="element-2" data-mp="23vul23bheeqe">
        <Testimonials data-id="element-3" data-mp="23u9ueosaffxt" />
        <Problem data-id="element-4" data-mp="23ut97wmn5o7m" />
        <Tomos data-id="element-5" data-mp="23t8ea5wf0398" />
        <Bonos data-id="element-6" data-mp="3ijxokogyjwiu" />
        <Offer data-id="element-7" data-mp="3ikha0f5th31m" />
        <PlanMaestro data-id="element-8" data-mp="3iiweam7rne26" />
        <MoreTestimonials data-id="element-9" data-mp="3ijfu9xduvsdk" />
        <Guarantee data-id="element-10" data-mp="3ii4r9zs8ioni" />
        <Faq data-id="element-11" data-mp="3mlaxj7fckftz" />
        <CostOfInaction data-id="element-12" data-mp="3mkrefndynled" />
        <FinalCta data-id="element-13" data-mp="3mjzsz5e2v41t" />
      </main>
      <Footer data-id="element-14" data-mp="3mj6hxs835sdv" />
    </div>;
}